import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss'],
})
export class PageLoaderComponent implements OnInit {
  @Input() loader: (() => Promise<boolean>) | null = null;
  constructor() {}

  ngOnInit(): void {
    this.load();
  }

  loading = false;
  hasMore = true;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop; //已滚动高度
    const clientHeight = document.documentElement.clientHeight; //屏幕显示高度
    const scrollHeight = document.documentElement.scrollHeight; //内容高度

    if (
      scrollTop + clientHeight > scrollHeight - 300 &&
      this.hasMore &&
      !this.loading
    ) {
      this.load();
    }
  }

  async load() {
    if (!this.loader) {
      return;
    }
    this.loading = true;
    this.hasMore = await this.loader();
    this.loading = false;
  }
}
